import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { MapService } from "../../../services/map.service";
import Overlay from 'ol/Overlay';
import VectorLayer from 'ol/layer/Vector';
import { Draw } from 'ol/interaction';
import VectorSource from 'ol/source/Vector';
import { Circle, Fill, Stroke, Style,Icon } from "ol/style";
import GeometryType from 'ol/geom/GeometryType';
import { LineString } from 'ol/geom';
import { unByKey } from 'ol/Observable';
import { transform } from 'ol/proj';
import { BingMaps, OSM, TileWMS } from 'ol/source';
import { environment } from 'src/environments/environment';
import { EcosistemasService } from 'src/app/services/ecosistemas.service';
import TileLayer from 'ol/layer/Tile';
import {getRenderPixel} from 'ol/render';

@Component({
  selector: 'app-navbar-map',
  templateUrl: './navbar-map.component.html',
  styleUrls: ['./navbar-map.component.scss']
})

export class NavbarMapComponent implements OnInit {

  @Input() empresas_checked: any
  @Input() map: any

  draw: Draw;
  vectorMeasure: VectorLayer;
  measureActive: boolean = false;

  basemap: any[]
  toggle:boolean = true;
  toggle_leyenda:boolean = true;
  toggle_MapaBase:boolean = true;
  toggle_capa:boolean = true;
  toggle_medir:boolean = true;
  toggle_info:boolean = true;
  toggle_principal:boolean = true;
  toggle_AVC:boolean = true;
  toggle_florafauna:boolean = true;
  toggle_cambios_coberturas:boolean = true;
  toggle_menudesplegable:boolean = true;
  toggle_swipe:boolean = true;
  start_date: String;
  end_date: String;
  arrinfo: Array<Object>;
  measureTooltipElement = null;
  measureTooltip = null;
  arrleyenda = [];
  LayerBase: any;
  capas_tematicas: any;


  constructor(
    public mapService: MapService,
    private ecosistemasService: EcosistemasService
  ) { 
    this.ecosistemasService.capas_tematicas$.subscribe( variable => {
      this.capas_tematicas = variable
    })
  }

  ngOnInit() {
    this.basemap = this.mapService.getBaseLayers();
    this.ecosistemasService.setButtonState('toggle_leyenda', true);
  }

  formatLength(line){
      var length = line.getLength();
      var output;
      if (length > 1000) {
        output = (Math.round(length / 1000 * 100) / 100) +
            ' ' + 'km';
      } else {
        output = (Math.round(length * 100) / 100) +
            ' ' + 'm';
      }
      return output;
  };
    
  formatArea(polygon) {
      var area = polygon.getArea();
      var output;
      if (area > 10000) {
        output = (Math.round(area / 10000 * 100) / 100) +
            ' ' + 'ha';
      } else {
        output = (Math.round(area * 100) / 100) +
            ' ' + 'm<sup>2</sup>';
      }
      return output;
  };

  createMeasureTooltip() {
      if (this.measureTooltipElement) {
        this.measureTooltipElement.parentNode.removeChild(this.measureTooltipElement);
      }
      this.measureTooltipElement = document.createElement('div');
      
      this.measureTooltipElement.className = 'ol-tooltip ol-tooltip-measure';
      this.measureTooltipElement.style.borderRadius = "4px";
      this.measureTooltipElement.style.position = "relative";
      this.measureTooltipElement.style.background = "rgba(0, 0, 0, 0.5)";
      this.measureTooltipElement.style.color = "white";
      this.measureTooltipElement.style.opacity = "0.7";
      this.measureTooltipElement.style.whiteSpace = "nowrap";
      this.measureTooltipElement.style.padding = "4px 8px"
      this.measureTooltipElement.style.border = "1px solid white";
      /*position: relative;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 4px;
      color: white;
      padding: 4px 8px;
      opacity: 0.7;
      white-space: nowrap;*/
    
      this.measureTooltip = new Overlay({
        element: this.measureTooltipElement,
        offset: [0, -15],
        //positioning: 'bottom-center'
      });
      this.map.addOverlay(this.measureTooltip);
  }
    
  addDrawInteraction() {
      if(this.toggle_info == false){
        this.toggle_info = !this.toggle_info;
        this.ecosistemasService.setButtonState('toggle_info', this.toggle_info);
      }
      this.toggle_medir = !this.toggle_medir;
      this.measureActive = !this.measureActive;
      console.log(this.measureActive);
      if(this.measureActive){
        var source = new VectorSource();
        this.vectorMeasure = new VectorLayer({
          source: source,
          style: new Style({
            fill: new Fill({
              color: 'rgba(255, 255, 255, 0.2)'
            }),
            stroke: new Stroke({
              color: '#6E2C00',
              width: 2
            }),
          })
        });
        
        this.map.addLayer(this.vectorMeasure)
    
        this.draw = new Draw({
          source: source,
          type: GeometryType.POLYGON,//LINE_STRING
          style: new Style({
            fill: new Fill({
              color: 'rgba(255, 255, 255, 0.2)'
            }),
            stroke: new Stroke({
              color: '#6E2C00',
              lineDash: [10, 10],
              width: 2
            }),
            image: new Circle({
              radius: 5,
              stroke: new Stroke({
                color: 'rgba(0, 0, 0, 0.7)'
              }),
              fill: new Fill({
                color: '#6E2C00'
              })
            })
          })
        });
        this.map.addInteraction(this.draw);
        this.createMeasureTooltip()

        var listener;
        //var measureTooltipElement = this.measureTooltipElement;
        //var measureTooltip = this.measureTooltip
    
        var sketch;
        const that = this;
        this.draw.on('drawstart',
        function(evt) {
    
          sketch = evt.feature;
          listener = sketch.getGeometry().on('change', function(evt) {
            var geom = evt.target;
            //formatLength(new ol.geom.LineString(geom.getLinearRing(0).getCoordinates())
            var coords = geom.getLinearRing(0).getCoordinates()
            coords.pop()
    
            that.measureTooltipElement.innerHTML = 'Área: '+ that.formatArea(geom)
                                                  + ' Distancia: '+that.formatLength(new LineString(coords));
            var tooltipCoord = geom.getInteriorPoint().getCoordinates();
            that.measureTooltip.setPosition(tooltipCoord);
          });
        });
    
        //var createMeasureTooltip = this.createMeasureTooltip
    
        this.draw.on('drawend',
          function() {
            // unset sketch
            var coords = sketch.getGeometry().getLinearRing(0).getCoordinates();
            if(sketch.getGeometry().getArea()==0){
              coords.pop()
              that.measureTooltipElement.innerHTML = 'Distancia: '+ that.formatLength(new LineString(coords));
            }else{
              that.measureTooltipElement.innerHTML = 'Área: '+ that.formatArea(sketch.getGeometry())
                                                // + ' Perimeter: '+this.formatLength(new LineString(coords));
            }
            sketch = null;
            that.measureTooltipElement.className = 'ol-tooltip ol-tooltip-static';
            that.measureTooltipElement.style.backgroundColor = "##6E2C00"
            that.measureTooltipElement.style.color = "white"
            that.measureTooltipElement.style.opacity = "1";
            that.measureTooltip.setOffset([0, -7]);
            that.measureTooltipElement = undefined;
            that.createMeasureTooltip()
            unByKey(listener);
        });
      }else{
        this.map.removeLayer(this.vectorMeasure);
        this.map.getOverlays().clear();
        this.map.removeInteraction(this.draw);
        this.vectorMeasure = undefined;
      }
  }

  limpiarfechas(){
  
  }

  AbrirLeyenda(){
    this.toggle_leyenda = !this.toggle_leyenda;
    this.ecosistemasService.setButtonState('toggle_leyenda', this.toggle_leyenda);
  }

  SeleccionMapaBase(){
    this.toggle_MapaBase = !this.toggle_MapaBase;
  }

  CambiandoMapaBase(event:any){
    this.map.getLayers().forEach(layer => {
      if (layer && layer.get('name') == 'CapaBase') {
        this.map.removeLayer(layer)
      }
    });
    if(event == "OS"){
      this.LayerBase = new TileLayer({
        visible: true,
        preload: Infinity,
        source: new OSM({})
      })
      this.LayerBase.set('name', 'CapaBase');
    }else{
      this.LayerBase = new TileLayer({
        visible: true,
        preload: Infinity,
        source: new BingMaps({
          key:
            "Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j",
          imagerySet: event,
        })
      })
      this.LayerBase.set('name', 'CapaBase');
    }
    this.map.getLayers().insertAt(0,this.LayerBase);
  }

  humanize(str) {
    return str
        .replace(/^[\s_]+|[\s_]+$/g, '')
        .replace(/[_\s]+/g, ' ')
        .replace(/^[a-z]/, function(m) { return m.toUpperCase(); });
  }

  info(){
    if(this.toggle_medir == false){
      this.toggle_medir = !this.toggle_medir;
      this.measureActive = !this.measureActive;
      this.map.removeLayer(this.vectorMeasure);
      this.map.getOverlays().clear();
      this.map.removeInteraction(this.draw);
      this.vectorMeasure = undefined;
    }
    this.toggle_info = !this.toggle_info
    this.ecosistemasService.setButtonState('toggle_info', this.toggle_info);
    document.getElementById("map").style.cursor = this.toggle_info ? "default" : "crosshair";
    var view = this.map.getView();
    var capas_t = this.capas_tematicas;
    var urlGeoserver = environment.urlGeoserver;
    this.arrinfo = [];
    var array = this.arrinfo;
    const ecosistemasService = this.ecosistemasService
    const humanize = this.humanize

    this.map.on('singleclick', function (evt) {
      array.length = 0;
      var viewResolution = /** @type {number} */ (view.getResolution());
      for(var i=0; i in capas_t; i++){
        if(capas_t[i].checked == "true"){
          var wmsSource = new TileWMS({
            url: urlGeoserver+'/wms',
            params: {'LAYERS': capas_t[i].value, 'TILED': true},
            serverType: 'geoserver',
            crossOrigin: 'anonymous',
          });
          var url = wmsSource.getFeatureInfoUrl(
            evt.coordinate,
            viewResolution,
            'EPSG:3857',
            {'INFO_FORMAT': 'application/json'}
          );
          if (url) {
            fetch(`https://api.allorigins.win/get?url=${encodeURIComponent(url)}`)
            .then(response => {
              if (response.ok) return response.json()
              throw new Error('Network response was not ok.')
            })
            .then(data => {
              var response = JSON.parse(data.contents);
              var list = response.features[0].properties;
              var values = Object.keys(list);
              var keys = Object.values(list);
              var arval = [];
              var namec;
              for(var i=0; i < values.length; i++){
                if(values[i] != 'id_layer' &&values[i] != 'nombre_capa' && values[i] != 'id_empresa' && values[i] != 'nombre_empresa' && values[i] != 'id_0' && values[i] != 'id_1' && values[i] != 'id_2' && values[i] != 'bbox' ){
                  arval.push([{key:humanize(values[i]), value:keys[i]}])
                }
                if(values[i] == 'nombre_capa'){
                  namec = humanize(keys[i]);
                }
              }
              array.push({
                "name": namec,
                "html":arval
              });
              ecosistemasService.updateInfo(array);
            });
          }
        }
      }
    });
  }

  SwipeUp(){
    this.toggle_swipe = !this.toggle_swipe
    this.ecosistemasService.setButtonState("toggle_swipe", this.toggle_swipe)
  }
  
}
